// Plugins
import './plugins/vue2-touch-events'
import './plugins/axios-config'
import './plugins/sweetalert2'
import quasarUserOptions from './plugins/quasar-user-options'
// Fim de Plugins

import Vue from 'vue'
import Quasar from 'quasar'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import ZoomOnHover from "vue-zoom-on-hover";
import VueRx from "vue-rx";
import VuejsClipper from 'vuejs-clipper'

import "@/design/index.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import tinymce from 'vue-tinymce-editor'
Vue.component('tinymce', tinymce)
Vue.use(Quasar, quasarUserOptions)
Vue.use(VueRouter)
Vue.use(ZoomOnHover);
Vue.use(VueRx);
Vue.use(VuejsClipper)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)

require('@/state/subscriber')

// Configuração do vue-shortkey
Vue.use(require('vue-shortkey'))


// Registra a diretiva personalizada global chamada `v-focus`
Vue.directive('focus', {
  // Quando o elemento vinculado é inserido no DOM...
  inserted: function (el) {
    // Coloque o foco no elemento
    el.focus()
  }
})
store.dispatch('window/changeWindowWidth', window.innerWidth)
  window.addEventListener("resize", () => {
    store.dispatch('window/changeWindowWidth', window.innerWidth);
    store.dispatch('window/changeWindowHeight', window.innerHeight);
})
// window.addEventListener("beforeunload", function (event) {
//   // Cancel the event as stated by the standard.
//   (event || window.event).preventDefault();
//   // Chrome requires returnValue to be set.
//   (event || window.event).returnValue = '';
// });
store.dispatch('keycloak/updateAuthFromLocalStorage')
store.dispatch('keycloak/getUserInfo', localStorage.getItem('token')).then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount("#app");
})




